export const LENDER_HUB_OFFER_REDUCER_PATH = "lenderHubOfferApi";

export const LENDER_HUB_OFFER_SERVICE_TAG = "LenderHubOffer";
export const LENDER_HUB_OFFER_FILE_SERVICE_TAG = "LenderHubOfferFile";

export const LENDER_HUB_OFFER_RELATED_TAGS = [LENDER_HUB_OFFER_SERVICE_TAG, LENDER_HUB_OFFER_FILE_SERVICE_TAG];
